/* eslint-disable max-classes-per-file */
import React, { Component } from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import APIHelper from "@giscon/utils.api-helper-esri";

import GraphicSelectorListItem from "./GraphicSelectorListItem";

const backgroundColor = "#B2D3DF"; // 'rgb(204, 215, 230)'; // giscon mittelblau // lightblue

class GraphicSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      graphicsLayer: APIHelper.createGraphicsLayer(),
      selection: null,
    };
    this.clones = {};
  }

  componentDidMount() {
    const { map } = this.props;
    const { graphicsLayer } = this.state;
    APIHelper.addToMap(map, graphicsLayer);
  }

  componentDidUpdate(prevProps) {
    const { graphicsLayer } = this.state;
    const { graphics } = this.props;
    if (prevProps.graphics !== graphics) {
      APIHelper.clearLayer(graphicsLayer);
      this.clones = {};
    }
  }

  componentWillUnmount() {
    const { map } = this.props;
    const { graphicsLayer } = this.state;
    APIHelper.removeFromMap(map, graphicsLayer);
  }

  select(graphic) {
    const { selectionCallback } = this.props;
    const { selection } = this.state;

    if (selection) this.unhighlight(selection, true);

    selectionCallback(graphic);
  }

  highlight(graphic) {
    // Symbol mit
    // graphic._sourceLayer.renderer.getSymbol(graphics)
    // ermitteln
    const { graphicsLayer } = this.state;
    if (graphic) {
      const { graphics } = this.props;
      const index = graphics.indexOf(graphic);
      if (index !== -1) {
        if (!this.clones[index]) {
          this.clones[index] = APIHelper.createHighlightGraphic(graphic);
        }
        APIHelper.addGraphicToLayer(this.clones[index], graphicsLayer);
      }
    }
  }

  unhighlight(graphic, force) {
    const { graphics } = this.props;
    // all if no graphic is given
    const { selection, graphicsLayer } = this.state;
    if (graphic) {
      const index = graphics.indexOf(graphic);
      if (index !== -1 && this.clones[index]) {
        APIHelper.removeGraphicFromLayer(this.clones[index], graphicsLayer);
      }
    } else {
      APIHelper.removeAllGraphicFromLayer(graphicsLayer);
    }
    if (graphic === selection && selection !== null && !force) {
      this.highlight(selection);
    }
  }

  render() {
    const { selection } = this.state;

    const {
      title,
      graphics,
      selectionCallback,
      forDeselection,
      nls,
      allowAbort,
    } = this.props;

    return (
      <div>
        <Card style={{ background: backgroundColor }}>
          <CardContent>
            <Typography variant="body2" component="p">
              {title}
            </Typography>
          </CardContent>
        </Card>
        <div>
          {graphics.map((graphic) => {
            return (
              <GraphicSelectorListItem // TODO: key property
                graphic={graphic}
                nls={nls}
                selected={graphic === selection}
                isEditorSelected={
                  (forDeselection || []).indexOf(graphic) !== -1
                }
                onHover={() => {
                  this.highlight(graphic);
                }}
                onBlur={() => {
                  this.unhighlight(graphic);
                }}
                onMouseOut={() => {
                  this.unhighlight(graphic);
                }}
                onClick={() => {
                  this.select(graphic);
                }}
              />
            );
          })}
        </div>
        <div>
          {/* <Button
            key="select"
            variant="contained"
            disabled={selection === null}
            onClick={() => {
              selectionCallback(selection);
            }}
            color="primary"
            style={{ marginRight: 10 }}
          >
            {nls.graphicSelectorSelect}
          </Button>
          */
          /* // TODO wieder einkommentieren wenn modus erschaffen für mehrfach selektion */}
          {allowAbort && (
            <Button
              variant="contained"
              key="abort"
              onClick={() => {
                selectionCallback(null);
              }}
              color="secondary"
            >
              {nls.graphicSelectorAbort}
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default GraphicSelector;
